module.exports = __webpack_public_path__ + "img/product_39.a5be10f.jpg";